import { render, staticRenderFns } from "./FormTagsDetecting.vue?vue&type=template&id=36763aa6&"
import script from "./FormTagsDetecting.vue?vue&type=script&lang=js&"
export * from "./FormTagsDetecting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports